import React, { Component } from "react";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import { connect } from "react-redux";
import _ from "i18n";
import {
  fetchCollaboratorsCalendar,
  fetchCollaboratorsSynthesis,
  fetchCollaboratorSuggestions,
  fetchSquadsSuggestions,
  fetchZoneSuggestions
} from "thunks";
import {
  initFilterCollaborator,
  setFilterCollaborators,
  setClientsDeletedStatus,
  setClientCRMGroup,
  setClientCRMType,
  setFilterSquads,
  setFilterYear,
  setFilterZone
} from "Actions";
import debounce from "lodash.debounce";
import styles from "./CalendarTablePage.local.scss";
import CheckBoxBtn from "../Common/Checkbox/CheckBoxBtn";
import {
  CLIENT_CRM_TYPE_FILTER,
  CLIENT_GROUP_CRM_FILTER,
  DELETED_STATUS
} from "../../config";
import moment from "moment";

class FilterCalendarTable extends Component {
  constructor(props) {
    super(props);
    this.loadZoneSuggestions = debounce(this.loadZoneSuggestions, 1000);
    this.loadSquadSuggestions = debounce(this.loadSquadSuggestions, 1000);
    this.loadCollaboratorSuggestions = debounce(
      this.loadCollaboratorSuggestions,
      1000
    );

    this.state = {
      expandedYearsDiv: false
    };
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearsSelect.bind(this)
    );
  }

  handleRefreshCollaboratorsSynthesis = () => {
    this.props.dispatch(fetchCollaboratorsSynthesis());
  };

  handleRefreshCollaboratorCalendar = () => {
    this.props.dispatch(fetchCollaboratorsCalendar());
  };

  handleYearsChange = selected => {
    this.setState(() => {
      this.props.dispatch(
        setFilterYear(
          selected.length === 0 ? [new Date().getFullYear()] : selected
        )
      );

      this.handleRefreshCollaboratorCalendar();
    });
  };

  handleSetDeletedStatus = selectedStatus => {
    const { activeTab } = this.props;
    this.props.dispatch(setClientsDeletedStatus(selectedStatus));
    activeTab === "CALENDAR" && this.handleRefreshCollaboratorCalendar();
    activeTab === "SYNTHESIS" && this.handleRefreshCollaboratorsSynthesis();
  };

  handleGroupCRMClientChange = selected => {
    const { activeTab } = this.props;
    this.props.dispatch(setClientCRMGroup(selected));
    activeTab === "CALENDAR" && this.handleRefreshCollaboratorCalendar();
    activeTab === "SYNTHESIS" && this.handleRefreshCollaboratorsSynthesis();
  };

  handleTypeCRMClientChange = selected => {
    const { activeTab } = this.props;
    this.props.dispatch(setClientCRMType(selected));
    activeTab === "CALENDAR" && this.handleRefreshCollaboratorCalendar();
    activeTab === "SYNTHESIS" && this.handleRefreshCollaboratorsSynthesis();
  };

  handleSquadChange = selected => {
    const { activeTab } = this.props;
    this.props.firstLoad();
    this.props.dispatch(setFilterSquads(selected));
    activeTab === "CALENDAR" && this.handleRefreshCollaboratorCalendar();
    activeTab === "SYNTHESIS" && this.handleRefreshCollaboratorsSynthesis();
  };
  loadSquadSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchSquadsSuggestions(searchWord))
      .then(res => {
        const squads = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(squads);
      })
      .catch(er => {
        callback([]);
      });
  };

  handleZoneChange = selected => {
    const { activeTab } = this.props;
    this.props.firstLoad();
    this.props.dispatch(setFilterZone(selected));
    this.props.dispatch(initFilterCollaborator());
    activeTab === "CALENDAR" && this.handleRefreshCollaboratorCalendar();

    activeTab === "SYNTHESIS" && this.handleRefreshCollaboratorsSynthesis();
  };
  loadZoneSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchZoneSuggestions(searchWord))
      .then(res => {
        const zones = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(zones);
        this.props.dispatch(setFilterZone(zones));
      })
      .catch(er => {
        callback([]);
      });
  };

  handleCollaboratorChange = selected => {
    if (selected.length === 0) {
      this.props.dispatch(setFilterZone([]));
    }
    this.props.firstLoad();
    this.props.dispatch(setFilterCollaborators(selected));
    this.handleRefreshCollaboratorCalendar();
  };

  loadCollaboratorSuggestions = (searchWord, callback) => {
    const { selectedCollaborator, zones, squads, years } = this.props;

    let selectedZones = zones.map(({ value }) => value);
    let selectedSquads = squads.map(({ value }) => value);

    this.props
      .dispatch(
        fetchCollaboratorSuggestions(
          searchWord,
          selectedZones,
          selectedSquads,
          years instanceof Array ? years : [years]
        )
      )
      .then(res => {
        let collaboratorsList = res.value.data.data.filter(
          item => item !== null
        );
        const collaborators = collaboratorsList.map(t => {
          return {
            value: t.id,
            label: t.name,
            color: "#000000"
          };
        });
        callback(collaborators);
        if (
          selectedCollaborator.length === 0 ||
          selectedCollaborator.length > 1
        ) {
          this.props.dispatch(
            setFilterCollaborators(zones.length > 0 ? collaborators : [])
          );
        }
      })
      .catch(er => {
        callback([]);
      });
  };

  handleYearsSynthesisChange = selected => {
    this.setState(() => {
      this.props.dispatch(setFilterYear(selected.toString()));
      this.props.dispatch(fetchCollaboratorsSynthesis());
    });
  };

  handleDeselectYear = year => {
    const { years } = this.props;

    let newSelectedYears =
      years instanceof Array && years.length === 0
        ? [new Date().getFullYear().toString()]
        : [...years];

    if (years.length === 1 && newSelectedYears.includes(year.toString())) {
      return;
    }
    if (newSelectedYears.includes(year.toString())) {
      newSelectedYears = years.filter(item => item !== year.toString());
      if (newSelectedYears.length === 0) {
        newSelectedYears = [new Date().getFullYear().toString()];
      }
    } else {
      newSelectedYears.push(year.toString());
    }

    this.handleYearsChange(newSelectedYears.filter(year => year !== undefined));
  };

  handleDisplayYearSelectItems = () => {
    let { expandedYearsDiv } = this.state;

    if (expandedYearsDiv === false) {
      this.setState({ expandedYearsDiv: true });
    } else {
      this.setState({ expandedYearsDiv: false });
    }
  };

  setYearsWrapperRef(node) {
    this.wrapperYearsRef = node;
  }

  renderYearLabel = () => {
    let { years } = this.props;

    return years instanceof Array ? new Date().getFullYear().toString() : years;
  };

  renderYearsLabel = () => {
    let { years } = this.props;
    let yearsLabel = "";

    let selectedYears =
      years instanceof Array && years.length > 0
        ? years
        : [new Date().getFullYear().toString()];

    selectedYears &&
      selectedYears.forEach((year, i) => {
        if (selectedYears.length === i + 1) {
          yearsLabel += year;
        } else {
          yearsLabel += year + "/";
        }
      });
    return selectedYears.length > 1 ? yearsLabel : selectedYears[0];
  };
  renderYearSelect = () => {
    const { years } = this.props;
    const { expandedYearsDiv } = this.state;
    let selectedYear =
      years instanceof Array ? new Date().getFullYear().toString() : years;

    let startDate = [moment().year() - 2, moment().year() - 1, moment().year()];

    return (
      <div
        ref={this.setYearsWrapperRef.bind(this)}
        className={
          styles.check_select +
          " " +
          (expandedYearsDiv === true ? styles.check_select_opened : "")
        }
      >
        <div className={styles.check_select_header}>
          <span>{this.renderYearLabel()}</span>
          <div className={styles.year_actions}>
            <div>
              <span
                className={styles.year_action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i
                  className={
                    expandedYearsDiv === true
                      ? "icon icon-arrow-up"
                      : "icon icon-arrow-down"
                  }
                />
              </span>
            </div>
          </div>
        </div>
        {expandedYearsDiv === true && (
          <div className={styles.check_select_body}>
            <div className={styles.check_select_body_options}>
              {startDate.map((year, index) => (
                <div key={index} className={styles.check_select_body_option}>
                  <CheckBoxBtn
                    id={year}
                    checked={year.toString() === selectedYear.toString()}
                    onChange={() => this.handleYearsSynthesisChange(year)}
                  />
                  {year}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  handleClickOutsideYearsSelect(event) {
    if (this.wrapperYearsRef && !this.wrapperYearsRef.contains(event.target)) {
      this.setState({ expandedYearsDiv: false });
    }
  }

  renderYearsSelect = () => {
    const { years } = this.props;
    const { expandedYearsDiv } = this.state;
    let selectedYears =
      years instanceof Array && years.length === 0
        ? [new Date().getFullYear().toString()]
        : years;

    let startDate = [moment().year() - 2, moment().year() - 1, moment().year()];

    return (
      <div
        ref={this.setYearsWrapperRef.bind(this)}
        className={
          styles.check_select +
          " " +
          (expandedYearsDiv === true ? styles.check_select_opened : "")
        }
      >
        <div className={styles.check_select_header}>
          <span>{this.renderYearsLabel()}</span>
          <div className={styles.year_actions}>
            <div>
              <span
                className={styles.year_action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i
                  className={
                    expandedYearsDiv === true
                      ? "icon icon-arrow-up"
                      : "icon icon-arrow-down"
                  }
                />
              </span>
            </div>
          </div>
        </div>
        {expandedYearsDiv === true && (
          <div className={styles.check_select_body}>
            <div className={styles.check_select_body_options}>
              {startDate.map((year, index) => (
                <div key={index} className={styles.check_select_body_option}>
                  <CheckBoxBtn
                    id={year}
                    checked={selectedYears.includes(year.toString())}
                    onChange={() => this.handleDeselectYear(year)}
                  />
                  {year}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };
  render() {
    let {
      calendarTableFilter,
      activeTab,
      label,
      nbResult,
      filter,
      listFilters
    } = this.props;

    let yearsOption = [];
    let startDate = [2021, 2020, 2019];
    // currentOrganization.startDate && currentOrganization.startDate.date
    //   ? renderYearsArrayBetweenStartDateAndNow(
    //       currentOrganization.startDate.date
    //     )
    //   : renderYearsArrayBetweenStartDateAndNow(new Date());
    startDate.forEach(item => {
      yearsOption.push({ value: item.toString(), label: item.toString() });
    });
    let filters = [
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: calendarTableFilter.zones.selected,
          placeholder: _("zone"),
          handleChange: this.handleZoneChange,
          loadSuggestions: this.loadZoneSuggestions,
          values: calendarTableFilter.zones
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: calendarTableFilter.squads.selected,
          placeholder: _("squad"),
          handleChange: this.handleSquadChange,
          loadSuggestions: this.loadSquadSuggestions,
          values: calendarTableFilter.squads
        }
      }
      // {
      //   grid: 3,
      //   type: "SELECT",
      //   options: {
      //     isSimple: false,
      //     isMulti: true,
      //     placeholder: _("year"),
      //     options: yearsOption.reverse(),
      //     action: this.handleYearsChange,
      //     values: calendarTableFilter.year.selected
      //   }
      // }
    ];

    if (activeTab === "CALENDAR") {
      filters.splice(1, 0, {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: calendarTableFilter.collaborator.selected,
          key:
            calendarTableFilter.zones.selected.length +
            calendarTableFilter.year.selected.length,
          placeholder: _("collaborator"),
          handleChange: this.handleCollaboratorChange,
          loadSuggestions: this.loadCollaboratorSuggestions,
          values: calendarTableFilter.collaborator
        }
      });
    }
    filters.splice(3, 0, {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: false,
        isMulti: true,
        isClearable: true,
        placeholder: _("Type Client (CRM)"),
        options: CLIENT_CRM_TYPE_FILTER,
        values: filter.clientCRMTypes,
        action: this.handleTypeCRMClientChange
      }
    });
    filters.splice(4, 0, {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: false,
        isMulti: true,
        isClearable: true,
        placeholder: _("Groupe Client (CRM)"),
        options: CLIENT_GROUP_CRM_FILTER,
        values: filter.clientCRMGroup,
        action: this.handleGroupCRMClientChange
      }
    });
    filters.splice(5, 0, {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: true,
        isClearable: true,
        placeholder: _("clientState"),
        options: DELETED_STATUS,
        values: listFilters.entityClientId.deletedStatus,
        action: this.handleSetDeletedStatus
      }
    });

    return (
      <div className="row align-center medium-12">
        <div className={`medium-12`}>
          <TTPFilterHorizontalBar
            button
            filters={filters}
            filterFormIsVisible={this.props.handleFilterFormIsVisible}
            cssClass="medium-12"
            customAddOn={
              activeTab === "CALENDAR"
                ? this.renderYearsSelect()
                : this.renderYearSelect()
            }
            label={activeTab === "SYNTHESIS" ? label : null}
            nbResult={nbResult}
          />
        </div>
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  data: state.calendarTable.calendar.data,
  months: state.calendarTable.months,
  calendarTableFilter: state.calendarTable.filter,
  currentOrganization: state.auth.currentOrganization,
  filter: state.financialSheet.periodTree.filter,
  listFilters: state.clients.filter,
  zones: state.calendarTable.filter.zones.selected,
  squads: state.calendarTable.filter.squads.selected,
  selectedCollaborator: state.calendarTable.filter.collaborator.selected,
  years: state.calendarTable.filter.year.selected
});

export default connect(mapStateToProps)(FilterCalendarTable);



// WEBPACK FOOTER //
// ./src/components/CalendarTable/FilterCalendarTable.js